(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jg-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jg-header')) {
    class JgHeader extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.section = this.closest('.jg-header-section');
        this.row = this.querySelector('.jg-header__row');
        this.desktop = this.querySelector('.jg-header__desktop');
        this.actions = this.querySelector('.jg-header__actions');
        this.toggle = this.querySelector('.jg-header__toggle');
        this.dialog = this.querySelector('.jg-menu');
        this.searchToggles = this.querySelectorAll('.jg-header__search-toggle');
        this.searchDialog = this.querySelector('.jg-search');
        this.cartLink = this.querySelector('.jg-header__cart');
        this.lastScroll = Math.max(0, window.scrollY);
        const options = { signal: this.controller.signal };
        document.addEventListener('pointerdown', () => { this.dataset.input = 'pointer'; }, options);
        document.addEventListener('keydown', () => { this.dataset.input = 'keyboard'; }, options);
        this.toggle?.addEventListener('click', (event) => this.openDialog(this.dialog, event), options);
        this.searchToggles.forEach((toggle) => toggle.addEventListener('click', (event) => {
          event.preventDefault();
          this.openDialog(this.searchDialog, event);
        }, options));
        this.querySelectorAll('.jg-dialog').forEach((dialog) => {
          dialog.querySelector('.jg-dialog__close').addEventListener('click', (event) => {
            if (dialog === this.dialog && dialog.classList.contains('is-closing')) this.openDialog(dialog, event);
            else this.closeDialog(dialog);
          }, options);
          dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.closeDialog(dialog); }, options);
          dialog.addEventListener('close', () => this.afterClose(dialog), options);
          dialog.addEventListener('click', (event) => {
            if (event.target.closest('a')) this.closeDialog(dialog, true);
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeDialog(dialog);
          }, options);
        });
        this.addEventListener('focusin', () => this.reveal(), options);
        document.addEventListener('shopify:section:select', (event) => { if (event.target === this.section) this.reveal(); }, options);
        this.cartLink?.addEventListener('click', (event) => this.openCart(event), options);
        this.querySelector('.jg-menu__cart')?.addEventListener('click', (event) => { this.closeDialog(this.dialog, true); this.openCart(event); }, options);
        this.cartLink?.addEventListener('keydown', (event) => {
          if (event.code === 'Space' && this.dataset.cartType === 'drawer') this.openCart(event);
        }, options);
        if (this.dataset.cartType === 'drawer') {
          this.cartLink?.setAttribute('role', 'button');
          this.cartLink?.setAttribute('aria-haspopup', 'dialog');
        }
        this.resizeObserver = new ResizeObserver(() => this.scheduleMeasure());
        [this.row, this.desktop, this.actions].forEach((element) => this.resizeObserver.observe(element));
        document.fonts?.ready.then(() => { if (this.isConnected) this.scheduleMeasure(); });
        window.addEventListener('resize', () => this.scheduleMeasure(), options);
        if (this.dataset.sticky === 'on-scroll-up') {
          window.addEventListener('scroll', () => {
            if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(() => this.onScroll());
          }, { passive: true, signal: this.controller.signal });
        }
        const ready = () => {
          if (!this.isConnected) return;
          this.setupNotification();
          this.classList.add('is-ready');
          this.measure();
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true, signal: this.controller.signal });
        else ready();
      }
      scheduleMeasure() {
        if (!this.resizeFrame) this.resizeFrame = requestAnimationFrame(() => { this.resizeFrame = null; this.measure(); });
      }
      measure() {
        const rowStyle = getComputedStyle(this.row);
        const brandWidth = this.querySelector('.jg-header__brand').getBoundingClientRect().width;
        const available = (this.row.clientWidth - parseFloat(rowStyle.paddingLeft) - parseFloat(rowStyle.paddingRight) - brandWidth - parseFloat(rowStyle.columnGap) * 2) / 2;
        const compact = window.innerWidth < 990 || this.desktop.scrollWidth > available;
        this.classList.toggle('is-compact', compact);
        this.desktop.inert = compact;
        if (!compact && this.dialog?.open) this.closeDialog(this.dialog, true);
        else if (this.dialog?.open) this.positionMenu();
        if (this.searchDialog?.open) this.positionSearch();
      }
      openDialog(dialog, event) {
        if (!dialog || (dialog.open && !dialog.classList.contains('is-closing'))) return;
        if (event) this.dataset.input = event.detail === 0 ? 'keyboard' : 'pointer';
        this.querySelectorAll('dialog[open]').forEach((other) => { if (other !== dialog) this.closeDialog(other, true); });
        this.reveal();
        if (dialog === this.dialog) {
          this.positionMenu();
          const menuCart = this.querySelector('.jg-menu__cart');
          if (menuCart && this.cartLink) menuCart.innerHTML = this.cartLink.innerHTML;
        }
        if (dialog === this.searchDialog) this.positionSearch();
        const previousHeight = dialog.open ? dialog.getBoundingClientRect().height : 0;
        this.menuAnimation?.cancel();
        this.menuAnimation = null;
        dialog.classList.remove('is-closing');
        if (!dialog.open) dialog.showModal();
        this.lockPage();
        if (dialog === this.searchDialog) dialog.querySelector('input[type="search"]').focus({ preventScroll: true });
        this.syncExpanded();
        if (dialog === this.dialog && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const height = dialog.getBoundingClientRect().height;
          const barHeight = parseFloat(dialog.style.getPropertyValue('--jg-menu-bar-height'));
          this.menuAnimation = dialog.animate([{ height: `${previousHeight || barHeight}px` }, { height: `${height}px` }], {
            duration: 200,
            easing: 'cubic-bezier(0.4, 0, 0.2, 1)'
          });
        }
      }
      closeDialog(dialog, immediate = false) {
        if (!dialog?.open) return;
        if (dialog !== this.dialog || immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          if (dialog === this.dialog) { this.menuAnimation?.cancel(); this.menuAnimation = null; }
          dialog.classList.remove('is-closing');
          dialog.close();
          this.afterClose(dialog);
          return;
        }
        if (dialog.classList.contains('is-closing')) return;
        const height = dialog.getBoundingClientRect().height;
        this.menuAnimation?.cancel();
        dialog.classList.add('is-closing');
        const animation = dialog.animate([{ height: `${height}px` }, { height: dialog.style.getPropertyValue('--jg-menu-bar-height') }], {
          duration: 200,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
          fill: 'forwards'
        });
        this.menuAnimation = animation;
        animation.finished.then(() => {
          if (this.menuAnimation !== animation) return;
          dialog.close();
          this.afterClose(dialog);
        }).catch(() => {});
      }
      positionSearch() {
        this.searchDialog.style.setProperty('--jg-search-top', `${Math.max(0, this.row.getBoundingClientRect().bottom)}px`);
        this.searchDialog.style.setProperty('--jg-search-width', `${this.getBoundingClientRect().width}px`);
      }
      positionMenu() {
        if (!this.dialog) return;
        const rect = this.row.getBoundingClientRect();
        const style = getComputedStyle(this.row);
        const brand = this.row.querySelector('.jg-header__brand');
        this.dialog.style.setProperty('--jg-menu-top', `${Math.max(0, rect.top)}px`);
        this.dialog.style.setProperty('--jg-menu-left', `${rect.left + 12}px`);
        this.dialog.style.setProperty('--jg-menu-width', `${rect.width - 24}px`);
        this.dialog.style.setProperty('--jg-menu-bar-height', `${rect.height}px`);
        this.dialog.style.setProperty('--jg-menu-logo-width', `${brand.getBoundingClientRect().width}px`);
        this.dialog.style.setProperty('--jg-menu-padding', `${Math.max(0, parseFloat(style.paddingLeft) - 12)}px`);
        this.dialog.style.setProperty('--jg-menu-gap', style.columnGap);
        const wordmark = brand.querySelector('.jg-header__wordmark');
        if (wordmark) this.dialog.style.setProperty('--jg-menu-wordmark-size', getComputedStyle(wordmark).fontSize);
      }
      lockPage() {
        if (this.pageLocked) return;
        this.bodyPadding = document.body.style.paddingRight;
        const gap = window.innerWidth - document.documentElement.clientWidth;
        if (gap > 0) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight) + gap}px`;
        this.pageLocked = true;
        document.body.classList.add('jg-menu-open');
      }
      syncExpanded() {
        this.toggle?.setAttribute('aria-expanded', String(Boolean(this.dialog?.open)));
        this.searchToggles.forEach((toggle) => toggle.setAttribute('aria-expanded', String(Boolean(this.searchDialog?.open))));
      }
      afterClose(dialog) {
        if (dialog === this.dialog && !dialog.open) {
          this.menuAnimation?.cancel();
          this.menuAnimation = null;
          dialog.classList.remove('is-closing');
        }
        if (!document.querySelector('.jg-dialog[open]')) {
          document.body.classList.remove('jg-menu-open');
          if (this.pageLocked) document.body.style.paddingRight = this.bodyPadding;
          this.pageLocked = false;
        }
        if (dialog === this.searchDialog && !dialog.open) dialog.querySelector('predictive-search')?.close?.();
        this.syncExpanded();
        this.reveal();
      }
      openCart(event) {
        if (this.dataset.cartType !== 'drawer') return;
        const drawer = document.querySelector('cart-drawer');
        if (typeof drawer?.open !== 'function') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.reveal();
        drawer.open(this.cartLink);
      }
      reveal() { this.section?.classList.remove('jg-header-is-hidden'); }
      onScroll() {
        this.scrollFrame = null;
        const scroll = Math.max(0, window.scrollY);
        const change = scroll - this.lastScroll;
        if (Math.abs(change) < 6 && scroll > 100) return;
        const keepVisible = scroll < 100 || this.querySelector('dialog[open]') || this.contains(document.activeElement) || this.notification?.classList.contains('active') || window.Shopify?.designMode;
        this.section.classList.toggle('jg-header-is-hidden', !keepVisible && change > 0);
        this.lastScroll = scroll;
      }
      setupNotification() {
        if (this.dataset.cartType !== 'notification') return;
        this.notification = this.section.querySelector('#cart-notification');
        if (this.notification) {
          this.notificationObserver = new MutationObserver(() => {
            if (this.notification.classList.contains('active')) this.reveal();
          });
          this.notificationObserver.observe(this.notification, { attributes: true, attributeFilter: ['class'] });
          const notice = this.section.querySelector('cart-notification');
          customElements.whenDefined('cart-notification').then(() => {
            if (!this.isConnected || !notice) return;
            notice.notification = this.notification;
          });
          this.notification.addEventListener('keyup', (event) => {
            if (event.code === 'Escape' && typeof notice?.close === 'function') notice.close();
          }, { signal: this.controller.signal });
        }
        const src = this.dataset.notificationScript;
        const alreadyLoading = Array.from(document.scripts).some((script) => script.src === new URL(src, document.baseURI).href);
        if (!customElements.get('cart-notification') && !alreadyLoading) {
          const script = document.createElement('script');
          script.src = src;
          script.async = true;
          document.head.appendChild(script);
        }
      }

      disconnectedCallback() {
        this.menuAnimation?.cancel();
        this.menuAnimation = null;
        this.querySelectorAll('dialog[open]').forEach((dialog) => this.closeDialog(dialog, true));
        this.afterClose();
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.notificationObserver?.disconnect();
        cancelAnimationFrame(this.resizeFrame);
        cancelAnimationFrame(this.scrollFrame);
      }
    }
    customElements.define('jg-header', JgHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('jg-thumb-rail')) {
  customElements.define('jg-thumb-rail', class extends HTMLElement {
    get slider() { return this.querySelector('.thumbnail-list'); }
    isSlideVisible(item, offset = 0) {
      const list = this.slider;
      if (!list || !item) return true;
      if (matchMedia('(min-width:750px)').matches) return item.offsetTop >= list.scrollTop && item.offsetTop + item.offsetHeight <= list.scrollTop + list.clientHeight;
      return item.offsetLeft >= list.scrollLeft && item.offsetLeft + item.offsetWidth <= list.scrollLeft + list.clientWidth - offset;
    }
  });
}
if (!customElements.get('jg-product-thumbs')) {
  customElements.define('jg-product-thumbs', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('product-info')?.querySelector('media-gallery');
      if (!this.gallery) return;
      this.sync = () => {
        if (!matchMedia('(min-width: 750px)').matches) return;
        const list = this.gallery.querySelector('.thumbnail-list');
        const current = list?.querySelector('[aria-current="true"]')?.closest('li');
        if (!current) return;
        const top = current.offsetTop;
        if (top < list.scrollTop) list.scrollTop = top;
        else if (top + current.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = top + current.offsetHeight - list.clientHeight;
      };
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.gallery, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
      this.sync();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
if (!customElements.get('jg-atc-price')) {
  customElements.define('jg-atc-price', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      this.button = this.closest('button');
      this.variant = JSON.parse(this.dataset.variant);
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: this.dataset.currency });
      this.update = () => {
        const quantity = Number(this.root.querySelector('[name="quantity"]')?.value || 1);
        if (!this.variant || !Number.isFinite(quantity) || quantity < 1) { this.hidden = true; return; }
        const plan = this.root.querySelector('[name="selling_plan"]')?.value;
        const allocation = this.variant.selling_plan_allocations?.find(item => String(item.selling_plan_id) === plan);
        let price = allocation?.price ?? this.variant.price;
        for (const tier of this.variant.quantity_price_breaks || []) if (quantity >= tier.minimum_quantity) price = tier.price;
        this.textContent = ' — ' + this.format.format(price * quantity / 100);
        this.hidden = false;
      };
      this.root.addEventListener('input', this.update);
      this.root.addEventListener('change', this.update);
      if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
        if (String(data.sectionId) !== this.root.dataset.section) return;
        this.variant = data.variant;
        this.update();
      });
      this.update();
    }
    disconnectedCallback() {
      this.root?.removeEventListener('input', this.update);
      this.root?.removeEventListener('change', this.update);
      this.unsubscribe?.();
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
